/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

const BhBusMidiaRedirect = (): any => {
  window.location.href = 'https://www.instagram.com/bhbusmidia/';
  return null;
};

export default BhBusMidiaRedirect;
